export default __webpack_public_path__ + "static/media/bgComunica.e69c1b18.jpg";